import { render } from "./ReservationManagement.vue?vue&type=template&id=c6edea36&scoped=true"
import script from "./ReservationManagement.vue?vue&type=script&lang=js"
export * from "./ReservationManagement.vue?vue&type=script&lang=js"

import "./ReservationManagement.vue?vue&type=style&index=0&id=c6edea36&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6edea36"]])

export default __exports__